import { WinLossDivisionAnalyticsDto } from '@/infrastructure/network/dto';

interface StatsTableRowProps {
	playerStats: WinLossDivisionAnalyticsDto;
}

export const StatsTableRow = ({ playerStats }: StatsTableRowProps) => {
	const tableCellStyle = 'px-3 py-4  sm:px-6 text-sm not-italic font-normal leading-5 text-start';

	return (
		<tr className="h-[72px] items-center text-sm font-normal leading-5 text-gray-600 odd:bg-white even:bg-gray-50">
			<td className={`${tableCellStyle} 'rounded-bl-lg'`}>
				<span className="relative inline-block rounded-sm">
					<span className="absolute right-[-1.3em] top-[-1em] rounded-sm flex h-4 w-3 items-center justify-center bg-darkorange-200 text-sm font-normal text-darkorange-300">
						{playerStats.tieBreakerWins}
					</span>
					<span className="text-sm font-normal text-gray-600">{playerStats.totalWins}</span>
				</span>
			</td>
			<td className={`${tableCellStyle}`}>{playerStats.totalLosses}</td>
			<td className={`${tableCellStyle}`}>{playerStats.totalPointsWon}</td>
			<td className={`${tableCellStyle}`}>{playerStats.totalPointsLost}</td>
			<td className={`${tableCellStyle}'rounded-br-lg' `}>{playerStats.pointDifferential}</td>
		</tr>
	);
};
